import React from 'react';
import { db } from '../firebase';
import { doc, setDoc } from 'firebase/firestore';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';

const SkinConcernsStep = ({ answers, setAnswers }) => {
  const options = ['جوش', 'لک', 'چروک', 'حساسیت', 'خشکی', 'منافذ', 'کدری', 'هایپرپیگمنتیشن'];

  const handleToggle = (concern) => {
    const updatedConcerns = answers.concerns.includes(concern)
      ? answers.concerns.filter(c => c !== concern)
      : [...answers.concerns, concern];
    
    setAnswers({ ...answers, concerns: updatedConcerns });
  };

  const addUserProfileToFirestore = async (user, profileData) => {
    try {
      await setDoc(doc(db, 'users', user.uid), {
        email: user.email,
        profileCompleted: false,
        ...profileData, // Add any additional profile data
      });
      console.log('User profile added to Firestore');
    } catch (error) {
      console.error('Error adding user profile to Firestore:', error);
    }
  };

  const registerUser = async (email, password, profileData) => {
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      await addUserProfileToFirestore(user, profileData);
      console.log('User registered and profile added to Firestore');
    } catch (error) {
      console.error('Error registering user:', error);
    }
  };

  return (
    <div className="text-center" dir="rtl">
      <h2 className="text-2xl font-bold mb-6 text-gray-800">
        چه مشکلات پوستی دارید؟ (چند گزینه قابل انتخاب است)
      </h2>
      <div className="grid grid-cols-3 gap-4">
        {options.map((option) => (
          <button
            key={option}
            onClick={() => handleToggle(option)}
            className={`p-4 rounded-lg border-2 transition-transform duration-200 transform hover:scale-105 focus:outline-none ${
              answers.concerns.includes(option)
                ? 'border-black bg-black text-white'
                : 'border-gray-300 bg-white text-gray-800 hover:bg-gray-50'
            }`}
          >
            <span className="text-sm font-medium">{option}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SkinConcernsStep; 